import { selectorAddressLine } from "@selectors/selectorAddressLine";
import { WSTableCell, WSTableColumn } from "@wingspanhq/fe-component-library";
import React from "react";

import { selectorWorksiteEngagementsSummary } from "../../selectors/selectorWorksiteEngagementsSummary";
import { WorksiteTableItem } from "./TableWorksites";

export const getColumns = (): WSTableColumn<WorksiteTableItem>[] => [
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: "Work site name" }
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={rowItem.data.worksite.name}
        secondaryText={rowItem.data.worksite.isPrimary ? "Primary" : undefined}
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: "Engagements" }
    },
    renderFunction: rowItem => {
      const summary = selectorWorksiteEngagementsSummary(
        rowItem.data.engagementNames
      );

      return (
        <WSTableCell
          text={summary.text}
          secondaryText={summary.secondaryText}
        />
      );
    }
  },
  {
    config: {
      gridTemplateSizeMax: "1fr",
      header: { text: "Address" }
    },
    renderFunction: rowItem => (
      <WSTableCell
        text={selectorAddressLine(rowItem.data.worksite.address) || "–"}
      />
    )
  },
  {
    config: {
      gridTemplateSizeMax: "0.6fr",
      header: { text: "External ID" }
    },
    renderFunction: rowItem => (
      <WSTableCell text={rowItem.data.worksite.externalId || "–"} />
    )
  }
];
